import React from 'react';
import {Button, Text, TextInput} from '@gravity-ui/uikit';
import styles from './CodeAuth.module.scss';
import {useCodeForm} from '../../model';

export const CodeAuth = () => {
  const {
    values,
    errors,
    handleChange,
    touched,
    handleBlur,
    handleSubmit,
    timer,
    isTimerActive,
    handleResendCode,
    errorMessage,
  } = useCodeForm();

  const handleInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <form onSubmit={handleSubmit} className={styles.form}>
      <div className={styles.inputWrapper}>
        <TextInput
          placeholder="Код подтверждения"
          size="xl"
          name="code"
          value={values.code}
          onChange={handleChange}
          onBlur={handleBlur}
          onKeyDown={handleInputKeyDown}
          autoFocus
          errorMessage={touched.code && errors.code}
          error={Boolean((touched.code && errors.code) || errorMessage)}
          errorPlacement={errors.code ? 'inside' : 'outside'}
        />
        {errorMessage && !isTimerActive && (
          <Text variant={'body-1'} color={'danger'}>
            {errorMessage}
          </Text>
        )}
      </div>

      <Button view="action" size="xl" width="max" type="submit" className={styles.submitButton}>
        Войти
      </Button>
      {isTimerActive ? (
        <div className={styles.timerContainer}>
          <Button view="flat" size="s" disabled className={styles.resendButton}>
            Получить код повторно {`0:${timer.toString().padStart(2, '0')}`}
          </Button>
        </div>
      ) : (
        <div className={styles.timerContainer}>
          <Button view="flat" size="s" onClick={handleResendCode} className={styles.resendButton}>
            Получить код повторно
          </Button>
        </div>
      )}
    </form>
  );
};
